export default __webpack_public_path__ + "static/media/logo.01c41ed5.svg";